import { render, staticRenderFns } from "./RegistrasiUserView.vue?vue&type=template&id=05cd1f4e"
import script from "./RegistrasiUserView.vue?vue&type=script&lang=js"
export * from "./RegistrasiUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports